import { Image } from '@/components'
import { Box, Typography } from '@mui/material'
import Link from 'next/link'
import MarqueeImage from './marque-image'
type Props = {
  commingSoon: boolean
  cate: ICategoryMenu
}
export default function ItemCategory({ commingSoon, cate }: Props) {
  return (
    <Box
      sx={{
        position: 'relative',
        transition: 'all 0.3s ease-in-out',
        borderRadius: '0.5rem',
        '&:hover .rfm-marquee-container': {
          opacity: '1 !important',
        },
        '&:hover': {
          backgroundColor: 'var(--mui-palette-primary-main)',
          boxShadow: '0 0.2rem 3rem #23232333',
          color: '#fff',
        },
        pointerEvents: commingSoon ? 'none' : 'auto',
      }}
    >
      {cate?.url_path && !commingSoon && (
        <Link
          href={cate.url_path}
          aria-label={cate?.name || 'category-link'}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
          }}
        />
      )}
      <Box
        sx={{
          aspectRatio: '306/408',
          borderRadius: 'inherit',
          overflow: 'hidden',
          position: ' relative',
        }}
      >
        <MarqueeImage />
        <Image
          src={cate?.image || ''}
          alt={cate?.name || ''}
          sx={{
            width: '100%',
            height: '100%',
            display: 'block',
            objectFit: 'cover',
          }}
        />
        {commingSoon && (
          <Box
            component={'span'}
            sx={{
              position: 'absolute',
              inset: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.01)',
              backdropFilter: 'blur(12px)',
              zIndex: 1,
            }}
          />
        )}
      </Box>
      <Typography
        variant="h3"
        sx={{
          fontSize: {
            xs: '1rem',
            lg: '1.25rem',
          },
          p: 1,
          textAlign: 'center',
          fontWeight: 600,
        }}
      >
        {cate?.name}{' '}
        {commingSoon && (
          <Box
            component="p"
            sx={{
              fontSize: '0.875rem',
              color: '#C84B00',
              fontWeight: 500, // Tăng weight để tăng độ rõ nét
            }}
          >
            Sắp ra mắt
          </Box>
        )}
      </Typography>
    </Box>
  )
}
